// @flow
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Actions from "../../actions/Creators";
import Scroll from "react-scroll";
import _ from "lodash";
import {
  Layout,
  ToggleButton,
  Loader,
  Pagination,
  EmptyResults,
  Icon,
  LocaleLink,
  SearchString,
  Button,
  Status
} from "../../components/common/";
import Print from "../../components/transfers/print/Print";
import {
  TransfersTable,
  AsnTable,
  CreateTransfers,
  PreviewTransfers
} from "../../components/transfers/";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import I18n from "../../i18n/I18n";
import Helper from "../../helper/Helper";
import styles from "./Transfers.scss";

class Transfers extends React.Component {
  state = {
    key: "",
    dir: "",
    limits: 20,
    page: 1,
    scrollPage: 1,
    scrollLimit: 20,
    initialChange: false,
    transfersType: 1,
    change: false,
    asnType: 1,
    receivedType: 1,
    view: "grid",
    search: "",
    printAsn: "",
    businessType:
      (this.props.transfer && this.props.transfer.lines) ||
      this.props.match.params.fbnAsn
        ? 2
        : 1,
    lineType: 1,
    typeChanged: false,
    selectedBatch: null,
    selectedStatus: "all",
    selectedWarehouse: "all",
    selectedRtvStatus: "all"
  };

  componentDidMount = () => {
    this.getWareHouses();
    this.getStatus();
    this.getRtvStatus();
    this.getIsOwnedWareHouses();
    if (this.props.user && this.props.seller) {
      if (this.props.match.params.asn) {
        this.getAsnData(this.props.match.params.asn);
      } else if (this.props.match.params.rtv) {
        this.getAsnData(this.props.match.params.rtv, null, "rtv");
      } else if (this.props.match.params.fbnAsn) {
        this.getFbnTransfersCount(this.props.match.params.fbnAsn);
        // this.getAsnData(this.props.match.params.fbnAsn, null, null, true);
      } else if (this.props.match.params.previewAsn) {
        this.getInitialLines(this.props.match.params.previewAsn);
      } else if (this.props.match.params.key === "create") {
        const query = `?is_fbn=1`;
        this.getWareHouses(query);
        const isOpen =
          this.props.transfer &&
          this.props.transfer.transfers &&
          this.props.transfer.transfers.lines &&
          !_.isEmpty(this.props.transfer.transfers.lines) &&
          this.props.transfer.transfers.lines.find(
            line => line && line.status === "open"
          );
        if (isOpen) {
          this.props.history.push(`/${Helper.getLocale()}/transfers`);
        }
      } else {
        this.getTransfersData();
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.change) {
      Scroll.animateScroll.scrollToTop({ delay: 0 });
      if (this.props.match.params.asn) {
        this.getAsnData(this.props.match.params.asn);
      } else if (this.props.match.params.rtv) {
        this.getAsnData(this.props.match.params.rtv, null, "rtv");
      } else if (
        this.props.match.params.fbnAsn &&
        this.props.transfer.transfersCount
      ) {
        this.getAsnData(this.props.match.params.fbnAsn, null, null, true);
      } else if (this.props.match.params.previewAsn) {
        this.getInitialLines(this.props.match.params.previewAsn);
      } else if (this.props.match.params.key === "create") {
        this.getTransfersData();
      } else {
        this.getTransfersData();
      }
    }
    if (this.state.initChange) {
      this.getToggledLine();
    }
    if (this.state.scrollPage && this.state.scrollPage > prevState.scrollPage) {
      this.setState({
        typeChanged: false
      });
      this.getToggledLine();
    }

    if (
      this.props.session &&
      prevProps.session &&
      this.props.session !== prevProps.session &&
      this.props.session.fbnWarehouses !== prevProps.session.fbnWarehouses
    ) {
      this.getWareHouses();
    }

    const { transfer, isOpening } = this.props;

    if (
      transfer &&
      transfer.transfersCount &&
      transfer.transfersCount.tabs &&
      this.props.match.params.fbnAsn &&
      !_.isEmpty(transfer.transfersCount.tabs) &&
      prevProps.transfer &&
      !prevProps.transfer.transfersCount
    ) {
      this.setState({
        change: true
      });
    }

    // if (
    //   transfer.batches &&
    //   !_.isEmpty(transfer.batches) &&
    //   transfer.batches !== prevProps.transfer.batches &&
    //   !this.props.isBatchesLoading &&
    //   prevProps.isBatchesLoading &&
    //   !this.state.selectedBatch
    // ) {
    //   // this.getToggledLine(
    //   //   this.state.lineType === 1 ? "initial" : "processed",
    //   //   transfer.batches[0].id_fbn_asn_batch
    //   // );
    //   this.setState({
    //     selectedBatch: transfer.batches[0].id_fbn_asn_batch
    //   });
    // }

    // if (
    //   transfer &&
    //   transfer.asn &&
    //   transfer.asn.asn_type &&
    //   prevProps.transfer.asn &&
    //   prevProps.transfer.asn.asn_type &&
    //   transfer.asn.asn_type !== prevProps.transfer.asn.asn_type
    // ) {
    //   this.setState({ businessType: 1 });
    // }

    if (
      transfer &&
      transfer.initialLines &&
      transfer.initialLines !== prevProps.transfer.initialLines &&
      transfer.initialLines.transfer_info &&
      !isOpening &&
      prevProps.isOpening
    ) {
      this.props.history.push(
        `/${Helper.getLocale()}/transfers/preview/${
          transfer.initialLines.transfer_info.asn_nr
        }`
      );
    }

    if (
      transfer &&
      transfer.isImportCompleted &&
      prevProps.transfer.isImporting &&
      transfer.success
    ) {
      this.getInitialLines(this.props.match.params.previewAsn);
    }

    if (
      transfer.success &&
      !prevProps.transfer.success &&
      !transfer.isImporting
    ) {
      this.getInitialLines(this.props.match.params.previewAsn);
    }

    if (
      this.state.print &&
      transfer !== prevProps.transfer &&
      (this.props.match.params.previewAsn || this.state.businessType === 2
        ? transfer.lines && transfer.lines !== prevProps.transfer.lines
        : transfer.asn !== prevProps.transfer.asn ||
          transfer.unidentifiedAsn !== prevProps.transfer.unidentifiedAsn) &&
      !this.props.isPrintLoading
    ) {
      this.printPreview();
    }

    if (
      (prevProps.match.params.asn && !this.props.match.params.asn) ||
      (prevProps.match.params.rtv && !this.props.match.params.rtv) ||
      (prevProps.match.params.fbnAsn && !this.props.match.params.fbnAsn)
    ) {
      this.setState({
        page: 1,
        change: true,
        search: ""
      });
    }

    if (
      (prevProps.match.params.previewAsn &&
        !this.props.match.params.previewAsn) ||
      (!prevProps.match.params.previewAsn && this.props.match.params.previewAsn)
    ) {
      this.setState({
        selectedBatch: null,
        search: ""
      });
    }

    if (!this.props.isClosing && prevProps.isClosing) {
      this.setState({
        change: true
      });
    }

    if (
      this.props.match.params.rtv &&
      transfer &&
      prevProps.transfer &&
      transfer.rtv &&
      transfer.rtv !== prevProps.transfer.rtv &&
      this.state.transfersType === 1
    ) {
      this.setState({
        transfersType: 2,
        change: true,
        page: 1
      });
    }
    if (this.state.transfersType !== prevState.transfersType) {
      this.setState({
        receivedType: 1,
        change: true,
        page: 1
      });
    }
    if (
      (this.props.match.params.asn &&
        this.props.match.params.asn !== prevProps.match.params.asn) ||
      (this.props.match.params.rtv &&
        this.props.match.params.rtv !== prevProps.match.params.rtv) ||
      (this.props.match.params.fbnAsn &&
        this.props.match.params.fbnAsn !== prevProps.match.params.fbnAsn)
    ) {
      this.setState({
        asnType: 1,
        search: "",
        change: true,
        page: 1,
        receivedType: 1,
        transfersType: this.props.match.params.rtv ? 2 : 1
      });
    }
  }

  componentWillReceiveProps = nextProps => {
    if (
      this.props.match !== nextProps.match ||
      this.props.seller !== nextProps.seller
    ) {
      this.getWareHouses();
      if (nextProps.match.params.asn) {
        this.getAsnData(nextProps.match.params.asn);
      } else if (nextProps.match.params.rtv) {
        this.getAsnData(nextProps.match.params.rtv, null, "rtv");
      } else if (nextProps.match.params.fbnAsn) {
        // this.getAsnData(nextProps.match.params.fbnAsn, null, null, true);
        this.getFbnTransfersCount(nextProps.match.params.fbnAsn);
      } else if (nextProps.match.params.previewAsn) {
        this.getInitialLines(nextProps.match.params.previewAsn);
      } else if (nextProps.match.params.key === "create") {
        // this.getTransfersData();
        this.setState({
          businessType: 2,
          change: true
        });

        const isOpen =
          nextProps.transfer &&
          nextProps.transfer.transfers &&
          nextProps.transfer.transfers.lines &&
          !_.isEmpty(nextProps.transfer.transfers.lines) &&
          nextProps.transfer.transfers.lines.find(
            line => line && line.status === "open"
          );

        if (isOpen) {
          this.props.history.push(`/${Helper.getLocale()}/transfers`);
        }
        // const query = `?is_fbn=1`;

        // this.getWareHouses(query);
      } else {
        this.getTransfersData();
      }
    }
  };

  getTransfersData = () => {
    const {
      key,
      dir,
      limits,
      page,
      search,
      transfersType,
      businessType,
      selectedStatus,
      selectedWarehouse,
      selectedRtvStatus
    } = this.state;

    let query = `limits=${limits}&page=${page}`;
    query = search ? `${query}&search=${search}` : query;
    query =
      selectedStatus !== "all" ? `${query}&status=${selectedStatus}` : query;
    query =
      selectedRtvStatus !== "all"
        ? `${query}&status=${selectedRtvStatus}`
        : query;
    query =
      selectedWarehouse !== "all"
        ? `${query}&id_warehouse=${selectedWarehouse}`
        : query;
    this.props.dispatch(
      Actions.getTransfers(query, transfersType === 2, businessType === 2)
    );

    const newState = {};
    newState.selectedBatch = null;
    newState.change = false;
    this.setState(newState);
  };
  closeAsn = (idWarehouse, idAsn) => {
    const warehouse = {
      id_partner_warehouse: idWarehouse,
      id_asn: idAsn
    };
    this.props.dispatch(Actions.closeAsn(warehouse));
  };

  openFbnAsn = whObj => {
    this.props.dispatch(Actions.openFbnAsn(whObj));
  };

  getStatus = () => {
    this.props.dispatch(Actions.getStatus());
  };

  getRtvStatus = () => {
    this.props.dispatch(Actions.getRtvStatuses());
  };

  retrieveSlots = obj => {
    this.props.dispatch(Actions.retrieveSlots(obj));
  };

  getAsnCount = asn => {
    const query = asn ? `asn_nr=${asn}` : "";
    Actions.getTransfersCount(query);
  };

  importFbnAsn = file => {
    this.props.dispatch(Actions.importFbnAsn(file));
  };

  scheduleAsn = obj => {
    this.props.dispatch(Actions.scheduleAsn(obj));
  };

  getAsnBatches = idFbnAsn => {
    const obj = {
      id_fbn_asn: idFbnAsn
    };
    this.props.dispatch(Actions.getAsnBatches(obj));
  };

  getWareHouses = query => {
    this.props.dispatch(Actions.getWareHouses(query));
  };

  // function for isOwned warehouses
  getIsOwnedWareHouses = query => {
    const fQuery = `?is_owned=1`;
    this.props.dispatch(Actions.getWareHouses(fQuery));
  };

  exportEligibleOffers = () => {
    this.props.dispatch(Actions.exportEligibleOffers());
  };

  getInitialLines = asn => {
    const {
      scrollLimit,
      scrollPage,
      lineType,
      selectedBatch,
      initChange
    } = this.state;
    const typeText = lineType === 1 ? "initial" : "scheduled";
    let query = asn ? `asn_nr=${asn}` : "";
    query =
      scrollLimit && scrollPage
        ? `${query}&limits=${scrollLimit}&page=${scrollPage}`
        : query;
    query =
      selectedBatch && lineType === 1
        ? `${query}&id_fbn_asn_batch=${selectedBatch}`
        : query;
    this.props.dispatch(Actions.getInitialLines(query, typeText));
    this.setState({
      initChange: false
    });
  };

  getToggledLine = () => {
    this.getInitialLines(this.props.match.params.previewAsn);
  };

  loadFunc = () => {
    if (
      this.props.transfer &&
      this.props.transfer.initialLines &&
      this.props.transfer.initialLines.no_of_pages &&
      this.props.transfer.initialLines.no_of_pages > this.state.scrollPage
    ) {
      this.setState({
        scrollPage: this.state.scrollPage + 1
      });
    }
    // this.getInitialLines(this.props.match.params.previewAsn, 20, 2);
  };

  getFbnTransfersCount = asn => {
    const query = asn ? `asn_nr=${asn}` : "";
    this.props.dispatch(Actions.getFbnTransfersCount(query));
    this.setState({
      change: false
    });
  };

  getAsnData = (asn, action, rtv, fbn, scheduled) => {
    const {
      key,
      dir,
      limits,
      page,
      search,
      asnType,
      receivedType,
      transfersType,
      businessType
    } = this.state;
    let type = "";
    const { transfer } = this.props;
    const print = action === "print";
    if (
      transfer &&
      transfer.transfersCount &&
      transfer.transfersCount.tabs &&
      !_.isEmpty(transfer.transfersCount.tabs)
    ) {
      if (receivedType > 0) {
        if (
          (businessType === 2 ? receivedType - 1 : receivedType - 1) <
          transfer.transfersCount.tabs.length
        ) {
          type =
            transfer.transfersCount.tabs[
              businessType === 2 ? receivedType - 1 : receivedType - 1
            ].code;
        } else {
          if (businessType !== 2) {
            // type = "unidentified";
          }
        }
      }
    }

    if (asnType === 2 && transfersType === 1) {
      type = rtv ? "unidentified" : "requested";
    }
    if (asn) {
      let query = `limits=${
        print || (action && action === "export") ? "10000" : limits
      }&page=${print ? "1" : page}`;
      query = asn ? `${query}&${rtv ? "rtv_nr" : "asn_nr"}=${asn}` : query;
      query =
        search &&
        (print || (action && action === "export")
          ? Object.keys(this.props.match.params).length > 1
          : true)
          ? `${query}&search=${search}`
          : query;
      query =
        type && type !== "summary" && type !== "identified"
          ? `${query}&type=${type}`
          : query;
      query = action && action === "export" ? `${query}&is_export=true` : query;
      if (fbn) {
        this.props.dispatch(Actions.getProcessedLines(query, print, scheduled));
      } else this.props.dispatch(Actions.getAsn(query, print, rtv));
      this.setState({
        change: false
      });
    }
  };

  onSearch = search => {
    const newState = {};
    newState.page = 1;
    newState.search = search;
    newState.change = true;
    this.setState(newState);
  };

  sortColumn = (key, dir) => {
    const newState = {};
    newState.key = key;
    newState.dir = dir;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  onPageChange = page => {
    const newState = {};
    newState.page = page.selected + 1;
    newState.change = true;
    this.setState(newState);
  };

  perPage = e => {
    const newState = {};
    newState.limits = e;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  // Status Filter Function
  statusChange = e => {
    const newState = {};
    newState.selectedStatus = e;
    newState.change = true;
    this.setState(newState);
  };

  // RTV Status Filter Function
  rtvStatusChange = e => {
    const newState = {};
    newState.selectedRtvStatus = e;
    newState.change = true;
    this.setState(newState);
  };

  // Warehouse filter Function
  warehouseChange = e => {
    const newState = {};
    newState.selectedWarehouse = e;
    newState.change = true;
    this.setState(newState);
  };

  clearSearch = () => {
    const newState = {};
    newState.search = "";
    newState.change = true;
    this.setState(newState);
  };

  toggleType = type => {
    const newState = {};

    if (this.props.match.params.asn || this.props.match.params.rtv) {
      newState.asnType = type;
      newState.transfersType = 1;
    } else {
      newState.transfersType = type;
      newState.asnType = 1;
      newState.businessType = 1;
    }
    newState.page = 1;
    newState.receivedType = 1;
    newState.change = true;
    newState.selectedStatus = "all";
    newState.selectedWarehouse = "all";
    this.setState(newState);
  };

  toggleBusiness = type => {
    const newState = {};

    newState.businessType = type;
    newState.transfersType = 1;
    newState.asnType = 1;
    newState.page = 1;
    newState.receivedType = 1;
    newState.change = true;
    newState.selectedStatus = "all";
    newState.selectedWarehouse = "all";
    this.setState(newState);
  };

  toggleLines = type => {
    const newState = this.state;
    const typeChanged = this.state.lineType !== type;
    const typeText = type === 1 ? "initial" : "scheduled";
    newState.scrollPage = 1;
    newState.lineType = type;
    newState.typeChanged = typeChanged;
    newState.selectedBatch =
      type === 1 &&
      this.props.transfer &&
      this.props.transfer.batches &&
      !_.isEmpty(this.props.transfer.batches)
        ? this.props.transfer.batches[0].id_fbn_asn_batch
        : null;
    newState.initChange = true;
    this.setState(newState);
  };

  toggleBatch = batch => {
    const newState = this.state;
    newState.scrollPage = 1;
    newState.typeChanged = false;
    newState.selectedBatch = batch;
    newState.initChange = true;
    this.setState(newState);
  };

  toggleReceived = type => {
    const newState = {};

    newState.receivedType = type;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  viewChange = e => {
    const newState = {};
    newState.view = e;
    this.setState(newState);
  };

  printCall = (asn, rtv, fbn, status) => {
    this.getAsnData(asn, "print", rtv, fbn, status && status !== "closed");
    this.setState({
      print: true,
      printAsn: asn
    });
  };

  exportAsn = (asn, rtv, fbn, status) => {
    this.getAsnData(asn, "export", rtv, fbn, status && status !== "closed");
  };

  goBack = () => {
    this.props.history.goBack();
  };

  printPreview = () => {
    this.setState({
      print: false
    });
    this.asn.onPrint();
  };

  setRef = ref => {
    this.asn = ref;
  };

  render() {
    const {
      seller,
      transfer,
      isLoading,
      sessionIsLoading,
      match,
      browser,
      isPrintLoading,
      isExportLoading,
      lang,
      warehouses,
      isOpening,
      isImportCompleted,
      isImporting,
      isExporting,
      isInitialLoaded,
      isInitialLoading,
      session,
      isBatchesLoading,
      isWareHousesLoading,
      isCountLoading,
      slots,
      isGettingSlots,
      status,
      isOwnedWarehouses,
      rtvStatus
    } = this.props;

    const barcodeRecvMethod =
      seller && seller.id_asn_recv_method && seller.id_asn_recv_method === 3;

    const {
      transfersType,
      receivedType,
      asnType,
      page,
      businessType,
      selectedStatus,
      selectedWarehouse,
      selectedRtvStatus
    } = this.state;
    //Mapping isOwned warehouses for filter dropdown
    const isOwnedWarehousesList = isOwnedWarehouses
      ? isOwnedWarehouses.warehouses
      : "";
    let isOwnedOptions = [{ label: "All", value: "all" }];

    if (isOwnedWarehousesList) {
      for (let i = 0; i < isOwnedWarehousesList.length; i++) {
        const isOwnedItem = [];
        isOwnedItem.label = isOwnedWarehousesList[i].code;
        isOwnedItem.value = isOwnedWarehousesList[i].id_warehouse;

        isOwnedOptions.push(isOwnedItem);
      }
    }

    //Mapping for status dropdown
    const statusList = status && status.statuses ? status.statuses : "";

    let statusOptions = [{ label: "All", value: "all" }];

    if (statusList) {
      for (let i = 0; i < statusList.length; i++) {
        const statusItem = [];
        statusItem.label = statusList[i];
        statusItem.value = statusList[i];

        statusOptions.push(statusItem);
      }
    }

    //Mapping for status dropdown
    const rtvStatusList =
      rtvStatus && rtvStatus.statuses ? rtvStatus.statuses : "";

    let rtvStatusOptions = [{ label: "All", value: "all" }];

    if (rtvStatusList) {
      for (let i = 0; i < rtvStatusList.length; i++) {
        const rtvStatusItem = [];
        rtvStatusItem.label = rtvStatusList[i];
        rtvStatusItem.value = rtvStatusList[i];

        rtvStatusOptions.push(rtvStatusItem);
      }
    }

    let { asn, rtv, key, previewAsn, fbnAsn } = match.params;
    let title = "transfers.title";

    let toggleItems = [
      I18n.getText("transfers.to-noon"),
      I18n.getText("transfers.from-noon")
    ];
    let toggleDirections = [
      I18n.getText("transfers.transfer-to-noon"),
      I18n.getText("transfers.transfer-from-noon")
    ];

    let businessItems = [
      I18n.getText("transfers.crossdock-b2b"),
      I18n.getText("products.noon-now")
    ];

    let typeOptions = [];

    if (
      transfer &&
      transfer.transfersCount &&
      transfer.transfersCount.tabs &&
      !_.isEmpty(transfer.transfersCount.tabs)
    ) {
      const { tabs, counts } = transfer.transfersCount;
      let totalCount = 0;
      for (let i = 0; i < tabs.length; i++) {
        totalCount += tabs[i].count;
        typeOptions.push(
          <div>
            {businessType !== 2
              ? tabs[i][`name_${Helper.getLang()}`]
              : tabs[i].status}{" "}
            {transfer && transfer.transfersCount
              ? `(${
                  businessType !== 2
                    ? tabs[i].count
                    : (counts && counts[tabs[i].code]) || 0
                })`
              : ""}
          </div>
        );
      }
      if (businessType !== 2) {
        // const summaryTab = [
        //   <div className={styles.typeOptions}>
        //     {I18n.getText("transfers.summary")}{" "}
        //     {totalCount > 0 ? `(${totalCount})` : ""}
        //   </div>
        // ];
        // typeOptions.splice(0, 0, summaryTab);
      }
      if (!rtv && businessType !== 2) {
        // typeOptions.push(
        //   <div className={styles.typeOptions}>
        //     {I18n.getText("transfers.unidentified")}{" "}
        //     {transfer && transfer.transfersCount
        //       ? `(${transfer.transfersCount.counts["unidentified"] || 0})`
        //       : ""}
        //   </div>
        // );
      }
    }

    let selectedType = transfersType;

    if (asn) {
      toggleItems = [
        I18n.getText("transfers.completed"),
        I18n.getText("transfers.requested")
      ];
      selectedType = asnType;
    } else if (rtv) {
      toggleItems = [
        I18n.getText("transfers.identified-items"),
        I18n.getText("transfers.unidentified-items")
      ];
      selectedType = asnType;
    }

    const viewOptions = [
      {
        value: "grid",
        key: "grid",
        label: <Icon name="table" className={styles.viewIconTable} />
      },
      {
        value: "box",
        key: "box",
        label: <Icon name="list-view" className={styles.viewIcon} />
      }
    ];

    const pageOptions =
      transfer && (transfer.transfers || transfer.asn)
        ? [
            {
              value: 20,
              key: 20,
              label: I18n.getText("orders.20-per-page", {}, "20 Per Page")
            },
            {
              value: 40,
              key: 40,
              label: I18n.getText("orders.40-per-page", {}, "40 Per Page")
            },
            {
              value: 60,
              key: 60,
              label: I18n.getText("orders.60-per-page", {}, "60 Per Page")
            }
          ]
        : [];

    let searchLabel = "transfers.search";

    if (transfersType === 2) {
      searchLabel = "transfers.rtv-search";
    }

    if (asn || rtv || fbnAsn || previewAsn) {
      searchLabel = "orders.new-search-placeholder";
    }

    const isFbnAllowed = seller && seller.is_allow_fbn_asn;

    const isOpen =
      transfer &&
      transfer.transfers &&
      transfer.transfers.lines &&
      !_.isEmpty(transfer.transfers.lines) &&
      transfer.transfers.lines.find(line => line && line.status === "open");

    return (
      <Layout
        currentIndex={8}
        title={title}
        onSearch={key !== "create" && !previewAsn && this.onSearch}
        searchLabel={searchLabel}
        search={this.state.search}
      >
        {seller ? (
          <div className={styles.mainCtr}>
            {key !== "create" && !previewAsn ? (
              <div>
                <div className={styles.topToggle}>
                  <div>
                    {asn || rtv || fbnAsn ? (
                      <div className={styles.backC}>
                        <a onClick={() => this.goBack()}>
                          {I18n.getText("transfers.go-back")}
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                    {!asn && !rtv && !fbnAsn ? (
                      <ToggleButton
                        toggleBtn={this.toggleType}
                        toggleItems={toggleDirections}
                        selected={selectedType}
                      />
                    ) : (
                      ""
                    )}
                    {asn ? (
                      <ToggleButton
                        toggleBtn={this.toggleType}
                        toggleItems={toggleItems}
                        selected={selectedType}
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  {!asn &&
                  !rtv &&
                  !fbnAsn &&
                  isFbnAllowed &&
                  businessType === 2 &&
                  !isOpen &&
                  !isLoading ? (
                    <div className={styles.fbnBtn}>
                      <LocaleLink to={`/transfers/create`}>
                        <Button
                          variant="primary"
                          className={styles.printCtr}
                          // onClick={() =>
                          //   this.exportAsn(asn || rtv, rtv ? "rtv" : null)
                          // }
                        >
                          <Icon name="list" className={styles.printIcon} />
                          {I18n.getText("transfers.create-fbn-transfers")}
                        </Button>
                      </LocaleLink>
                    </div>
                  ) : (
                    ""
                  )}
                  {asn || rtv || fbnAsn ? (
                    <div className={styles.backBtn}>
                      <div
                        className={styles.titleCtr}
                        style={{ marginLeft: "20px" }}
                      >
                        <h6 className={styles.sub}>
                          {I18n.getText(
                            rtv ? "transfers.rtv-nr" : "transfers.asn-id"
                          )}
                        </h6>
                        <h6 className={styles.main}>
                          {`${asn || rtv || fbnAsn}`}{" "}
                        </h6>
                      </div>
                      {isLoading ||
                      (transfer &&
                        transfer.asn &&
                        transfer.asn.asn_type === "invalid") ? (
                        ""
                      ) : transfer && transfer.asn ? (
                        <div className={styles.titleCtr}>
                          <h6 className={styles.sub}>
                            {I18n.getText("transfers.direction")}
                          </h6>
                          <h6 className={styles.main}>
                            <span>
                              {I18n.getText(
                                transfer.asn.asn_type === "fromnoon"
                                  ? "transfers.from-noon"
                                  : "transfers.to-noon"
                              )}
                            </span>
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfer &&
                      transfer.asn &&
                      ((transfer.asn.asn && transfer.asn.asn.received_at) ||
                        (transfer.asn.rtv && transfer.asn.rtv.received_at)) ? (
                        <div
                          className={styles.titleCtr}
                          style={{
                            marginLeft: "20px"
                          }}
                        >
                          <h6 className={styles.sub}>
                            {I18n.getText("transfers.received-at")}
                          </h6>
                          <h6 className={styles.main}>
                            {moment(
                              transfer.asn.asn
                                ? transfer.asn.asn.received_at
                                : transfer.asn.rtv.received_at
                            ).format(
                              `YYYY-MM-DD [${
                                lang === "ar" ? "" : "at"
                              }] h:mm:ss a`
                            )}
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfer &&
                      transfer.asn &&
                      ((transfer.asn.asn && transfer.asn.asn.warehouse_from) ||
                        (transfer.asn.rtv &&
                          transfer.asn.rtv.warehouse_from)) &&
                      (asn || rtv) ? (
                        <div
                          className={styles.titleCtr}
                          style={{
                            marginLeft: "20px"
                          }}
                        >
                          <h6 className={styles.sub}>
                            {I18n.getText("transfers.origin")}
                          </h6>
                          <h6 className={styles.main}>
                            {transfer.asn.asn
                              ? transfer.asn.asn.warehouse_from
                              : transfer.asn.rtv.warehouse_from}
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfer &&
                      transfer.lines &&
                      (transfer.lines.transfer_info &&
                        transfer.lines.transfer_info.warehouse_from) &&
                      fbnAsn ? (
                        <div
                          className={styles.titleCtr}
                          style={{
                            marginLeft: "20px"
                          }}
                        >
                          <h6 className={styles.sub}>
                            {I18n.getText("transfers.from-wh")}
                          </h6>
                          <h6 className={styles.main}>
                            {transfer.lines.transfer_info.warehouse_from}
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfer &&
                      transfer.lines &&
                      (transfer.lines.transfer_info &&
                        transfer.lines.transfer_info.warehouse_to) &&
                      fbnAsn ? (
                        <div
                          className={styles.titleCtr}
                          style={{
                            marginLeft: "20px"
                          }}
                        >
                          <h6 className={styles.sub}>
                            {I18n.getText("transfers.to-wh")}
                          </h6>
                          <h6 className={styles.main}>
                            {transfer.lines.transfer_info.warehouse_to}
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfer &&
                      transfer.asn &&
                      ((transfer.asn.asn && transfer.asn.asn.warehouse_to) ||
                        (transfer.asn.rtv && transfer.asn.rtv.warehouse_to)) &&
                      (asn || rtv) ? (
                        <div
                          className={styles.titleCtr}
                          style={{
                            marginLeft: "20px"
                          }}
                        >
                          <h6 className={styles.sub}>
                            {I18n.getText("transfers.destination")}
                          </h6>
                          <h6 className={styles.main}>
                            {transfer.asn.asn
                              ? transfer.asn.asn.warehouse_to
                              : transfer.asn.rtv.warehouse_to}
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfer.asn &&
                      transfer.asn.asn &&
                      transfer.asn.asn.status &&
                      asn ? (
                        <div
                          className={styles.titleCtr}
                          style={{
                            marginLeft: "20px"
                          }}
                        >
                          <h6 className={styles.sub}>
                            {I18n.getText("imports.status")}
                          </h6>
                          <h6 className={styles.main}>
                            <Status status={transfer.asn.asn.status} />
                          </h6>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className={`${styles.flexer} ${fbnAsn ? "" : styles.tabView}`}
                >
                  {transfer &&
                  transfer.lines &&
                  transfer.lines.transfer_info &&
                  fbnAsn ? (
                    <Status status={transfer.lines.transfer_info.status} />
                  ) : (
                    ""
                  )}
                  <div className={styles.toggleCtr}>
                    {!asn && !rtv && !fbnAsn && transfersType === 1 ? (
                      <div>
                        <ToggleButton
                          toggleBtn={this.toggleBusiness}
                          toggleItems={businessItems}
                          selected={businessType}
                          tab
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.search ? (
                      <SearchString
                        search={this.state.search}
                        clearSearch={this.clearSearch}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    <div className={styles.filterCtr}>
                      {(asn || rtv) &&
                      transfer &&
                      transfer.asn &&
                      transfer.asn.items &&
                      // asnType === 1 &&
                      !_.isEmpty(transfer.asn.items) ? (
                        <div className={styles.eachFilter}>
                          <Button
                            variant="transparent"
                            className={styles.printCtr}
                            onClick={() =>
                              this.exportAsn(asn || rtv, rtv ? "rtv" : null)
                            }
                          >
                            <Icon
                              name="download"
                              className={styles.printIcon}
                            />
                            {isExportLoading ? (
                              <div className={styles.loader} />
                            ) : (
                              I18n.getText(
                                rtv
                                  ? "transfers.export-rtv"
                                  : "statement.export-asn"
                              )
                            )}
                          </Button>
                        </div>
                      ) : (
                        ""
                      )}
                      {(asn || rtv) &&
                      transfer &&
                      transfer.asn &&
                      transfer.asn.items &&
                      // asnType === 1 &&
                      !_.isEmpty(transfer.asn.items) ? (
                        <div className={styles.eachFilter}>
                          <Button
                            variant="transparent"
                            className={styles.printCtr}
                            onClick={() =>
                              this.printCall(asn || rtv, rtv ? "rtv" : null)
                            }
                          >
                            <Icon name="print" className={styles.printIcon} />
                            {isPrintLoading ? (
                              <div className={styles.loader} />
                            ) : (
                              I18n.getText("statement.tooltip-print")
                            )}
                          </Button>
                        </div>
                      ) : (
                        ""
                      )}
                      {transfersType === 1 && businessType === 1 && (
                        <div className={styles.eachFilter}>
                          <Dropdown
                            onChange={this.warehouseChange}
                            selected={selectedWarehouse}
                            options={isOwnedOptions}
                            label={I18n.getText("filter.warehouse")}
                          />
                        </div>
                      )}
                      {transfersType === 1 && businessType === 1 && (
                        <div className={styles.eachFilter}>
                          <Dropdown
                            onChange={this.statusChange}
                            selected={selectedStatus}
                            options={statusOptions}
                            label={I18n.getText("filter.status")}
                          />
                        </div>
                      )}

                      {transfersType === 2 && (
                        <div className={styles.eachFilter}>
                          <Dropdown
                            onChange={this.rtvStatusChange}
                            selected={selectedRtvStatus}
                            options={rtvStatusOptions}
                            label={I18n.getText("filter.status")}
                          />
                        </div>
                      )}
                      {browser && browser.greaterThan.desktop ? (
                        <div className={styles.eachFilter}>
                          <Dropdown
                            onChange={this.viewChange}
                            selected={this.state.view}
                            options={viewOptions}
                            label={I18n.getText("filter.view")}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      <div className={styles.eachFilter}>
                        <Dropdown
                          onChange={this.perPage}
                          selected={this.state.limits}
                          options={pageOptions}
                          label={I18n.getText("orders.display")}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {(asn || fbnAsn || rtv) && asnType === 1 ? (
                  <ToggleButton
                    toggleBtn={this.toggleReceived}
                    tab
                    toggleItems={typeOptions}
                    selected={receivedType}
                  />
                ) : (
                  ""
                )}

                {isLoading || sessionIsLoading || (fbnAsn && isCountLoading) ? (
                  <div>
                    <Loader />
                  </div>
                ) : (
                  <div>
                    {!asn && !rtv && !fbnAsn ? (
                      transfer &&
                      transfer.transfers &&
                      ((businessType === 1 &&
                        transfer.transfers.asn &&
                        !_.isEmpty(transfer.transfers.asn)) ||
                        (businessType === 2 &&
                          transfer.transfers.lines &&
                          !_.isEmpty(transfer.transfers.lines))) ? (
                        <div>
                          <TransfersTable
                            data={
                              businessType === 2
                                ? transfer.transfers.lines
                                : transfer.transfers.asn
                            }
                            transfersType={transfersType}
                            browser={browser}
                            seller={seller}
                            isFbn={businessType === 2}
                            isPrintLoading={isPrintLoading}
                            closeAsn={this.closeAsn}
                            printCall={this.printCall}
                            exportAsn={this.exportAsn}
                            searchString={this.state.search}
                            view={this.state.view}
                          />
                          {transfer.transfers.no_of_pages &&
                          transfer.transfers.no_of_pages > 1 ? (
                            <div className={styles.paginationWrapper}>
                              <Pagination
                                pageCount={Number(
                                  transfer.transfers.no_of_pages
                                )}
                                currentPage={page}
                                onPageChange={this.onPageChange}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <EmptyResults
                          heading={I18n.getText("transfers.empty")}
                        />
                      )
                    ) : (transfer && transfer.asn && transfer.asn.items) ||
                      (transfer && transfer.lines && transfer.lines.lines) ? (
                      <div>
                        <div className={styles.tabCtr}>
                          {_.isEmpty(
                            transfer.asn
                              ? transfer.asn.items
                              : transfer.lines.lines
                          ) ? (
                            <EmptyResults
                              heading={I18n.getText("transfers.empty")}
                            />
                          ) : (
                            <AsnTable
                              data={
                                transfer.asn
                                  ? transfer.asn.items
                                  : transfer.lines.lines
                              }
                              lang={this.props.lang}
                              receivedType={receivedType}
                              transfersType={transfersType}
                              asnType={asnType}
                              seller={seller}
                              barcodeRecvMethod={barcodeRecvMethod}
                              businessType={businessType}
                              searchString={this.state.search}
                              history={this.props.history}
                              view={this.state.view}
                              browser={browser}
                            />
                          )}
                        </div>

                        {transfer[transfer.asn ? "asn" : "lines"].no_of_pages &&
                        transfer[transfer.asn ? "asn" : "lines"].no_of_pages >
                          1 ? (
                          <div className={styles.paginationWrapper}>
                            <Pagination
                              pageCount={Number(
                                transfer[transfer.asn ? "asn" : "lines"]
                                  .no_of_pages
                              )}
                              currentPage={page}
                              onPageChange={this.onPageChange}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <EmptyResults heading={I18n.getText("transfers.empty")} />
                    )}
                  </div>
                )}
              </div>
            ) : previewAsn ? (
              <div>
                {transfer &&
                transfer.initialLines &&
                transfer.initialLines.transfer_info ? (
                  <PreviewTransfers
                    asnInfo={transfer.initialLines.transfer_info}
                    setRef={this.setRef}
                    initialLines={transfer.initialLines.lines}
                    batches={transfer.batches}
                    isBatchesLoading={isBatchesLoading}
                    importFbnAsn={this.importFbnAsn}
                    isImportCompleted={isImportCompleted}
                    isImporting={isImporting}
                    scrollPage={this.state.scrollPage}
                    noOfPages={this.props.transfer.initialLines.no_of_pages}
                    history={this.props.history}
                    browser={browser}
                    seller={seller}
                    getAsnBatches={this.getAsnBatches}
                    typeChanged={this.state.typeChanged}
                    loadFunc={this.loadFunc}
                    importedBatch={
                      transfer &&
                      transfer.success &&
                      transfer.success.id_fbn_asn_batch
                    }
                    scheduleAsn={this.scheduleAsn}
                    toggleLines={this.toggleLines}
                    toggleBatch={this.toggleBatch}
                    currentBatch={this.state.selectedBatch}
                    lineType={this.state.lineType}
                    exportEligibleOffers={this.exportEligibleOffers}
                    isLoading={isLoading}
                    isInitialLoaded={isInitialLoaded}
                    isInitialLoading={isInitialLoading}
                    printCall={this.printCall}
                    exportAsn={this.exportAsn}
                    retrieveSlots={this.retrieveSlots}
                    isExportLoading={isExportLoading}
                    slots={slots}
                    isGettingSlots={isGettingSlots}
                    barcodeRecvMethod={barcodeRecvMethod}
                  />
                ) : isInitialLoading ? (
                  <Loader />
                ) : (
                  <EmptyResults heading={I18n.getText("transfers.empty")} />
                )}
              </div>
            ) : isLoading ? (
              <Loader />
            ) : businessType === 2 &&
              !isOpen &&
              !isLoading &&
              !isWareHousesLoading ? (
              <CreateTransfers
                warehouses={warehouses && warehouses.warehouses}
                openFbnAsn={this.openFbnAsn}
                isOpening={isOpening}
                isExporting={isExporting}
                getWareHouses={this.getWareHouses}
                fbnWarehouses={
                  session &&
                  session.warehousesbyWh &&
                  session.warehousesbyWh.warehouses
                }
                exportEligibleOffers={this.exportEligibleOffers}
              />
            ) : isWareHousesLoading ? (
              <Loader />
            ) : (
              <EmptyResults />
            )}
          </div>
        ) : (
          ""
        )}
        {transfer && seller && (
          <Print
            setRef={this.setRef}
            asn={
              transfer &&
              (businessType === 2 || previewAsn ? transfer.lines : transfer.asn)
            }
            selectedTab={
              transfer &&
              transfer.transfersCount &&
              transfer.transfersCount.tabs &&
              receivedType > 1 &&
              transfer.transfersCount.tabs[receivedType - 2][
                `name_${Helper.getLang()}`
              ]
            }
            lang={lang}
            businessType={previewAsn ? 2 : businessType || 1}
            transfersType={transfersType}
            unidentifiedAsn={transfer.unidentifiedAsn}
            printAsn={this.state.printAsn}
            seller={seller}
            barcodeRecvMethod={barcodeRecvMethod}
          />
        )}
      </Layout>
    );
  }
}
const mapStateToProps = state => ({
  sessionIsLoading: state.session.isLoading,
  isWareHousesLoading: state.session.isWareHousesLoading,
  session: state.session,
  lang: state.locale.lang,
  user: state.session.user,
  seller: state.session.seller,
  browser: state.browser,
  transfer: state.transfer,
  isLoading: state.transfer.isLoading,
  isCountLoading: state.transfer.isCountLoading,
  isBatchesLoading: state.transfer.isBatchesLoading,
  isPrintLoading: state.transfer.isPrintLoading,
  isExportLoading: state.transfer.isExportLoading,
  slots: state.transfer.slots,
  isGettingSlots: state.transfer.isGettingSlots,
  isClosing: state.transfer.isClosing,
  isOpening: state.transfer.isOpening,
  isImporting: state.transfer.isImporting,
  isExporting: state.transfer.isExporting,
  isInitialLoaded: state.transfer.isInitialLoaded,
  isInitialLoading: state.transfer.isInitialLoading,
  isImportCompleted: state.transfer.isImportCompleted,
  warehouses: state.session.wareHouses,
  isOwnedWarehouses: state.session.ownedWarehouses,
  status: state.transfer.status,
  rtvStatus: state.transfer.rtvStatus
});

export default connect(mapStateToProps)(Transfers);



// WEBPACK FOOTER //
// ./src/containers/transfers/Transfers.js